/**
 * contiene la información para el manejo de HMIS.
 */
export const defaultHmis = () => {
    return {
        id: 3,
        opsalud: '',
        inflamabilidad: '',
        fisico: '',
        saludHMIS: [],
        salud: ['Crónico', 'Piel', 'Ojos', 'Sistema Respiratorio', 'SNC', 'Higado', 'Riñones', 'Sangre', 'Reproducción'],
        saludbd: ['cronico', 'piel', 'ojos', 'sistemarespiratorio', 'snc', 'higado', 'rinones', 'sangre', 'reproduccion'],
        peligrosHMIS: [],
        peligros: ['Inflamable', 'Gas', 'Reactivo Inestable', 'Reactivo al agua', 'Oxidante', 'Peróxido', 'Pirofórico', 'Explosivo'],
        peligrosbd: ['inflamablesino', 'gas', 'reactivoinestable', 'reactivoalagua', 'oxidante', 'peroxido', 'piroforico', 'explosivo'],
        letrasHMIS: [],
        letras: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'X'],
        otrasLetrasHMIS: [],
        otrasLetras: ['n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'w', 'y', 'z'],
        ambientalHMIS: [
            { value: '', text: '' },
            { value: 'A', text: 'A' },
            { value: 'B', text: 'B' },
            { value: 'C', text: 'C' },
            { value: 'D', text: 'D' },
            { value: 'E', text: 'E' },
            { value: 'F', text: 'F' },
            { value: 'G', text: 'G' },
            { value: 'O', text: 'O' }
        ],
        ambiental: '',
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedHmis: defaultHmis(),
    opcSalud: [],
    opcInflamabilidad: [],
    opcPelFisico: [],
    opciones: []
}
